export default function extraMeta() {
    if (window.localStorage.getItem('metadata-video-tracking')) {
        const obj = JSON.parse(window.localStorage.getItem('metadata-video-tracking'));
        window.localStorage.removeItem('metadata-video-tracking');
        return obj;
    }
    return false;
}
